module.exports = __webpack_public_path__ + "img/company_cert_bg_2.c682a5c8.png";